/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import get from 'lodash/get'
import merge from 'lodash/merge'
import pick from 'lodash/pick'
import assign from 'lodash/assign'
import isEmpty from 'lodash/isEmpty'
import isFunction from 'lodash/isFunction'
import axios from 'axios'
import Cookies from 'js-cookie'
import { APP as apiConfig } from 'Configs/App'

import { API_CALL } from 'Constants/ids'

import { getAccessToken } from 'Redux/selectors/auth'

const ga = [
  ['_ga', Cookies.get('_ga')],
  ['_ga_SL7L905HG4', Cookies.get('_ga_SL7L905HG4')],
  ['_ga_KW228JVF2P', Cookies.get('_ga_KW228JVF2P')],
].reduce((acc, item) => {
  if (item[1]) {
    return `${acc}${item[0]}=${item[1]}; `
  }
  return acc
}, '')

export const ApiService = {
  apiCall: (
    url = apiConfig.SERVER,
    endpoint = '',
    method = 'GET',
    query = {},
    headers = {},
    qsParams = {}
  ) => {
    const HTTPMethod = method.toLowerCase()
    const isCookies =
      ga &&
      typeof endpoint === 'string' &&
      !endpoint.startsWith('https://api.spotify.com')

    const api = axios.create({
      baseURL: url,
      headers: {
        ...headers,
        ...(isCookies && { Cookies: ga }),
      },

      params: qsParams,
    })

    const body = method === 'delete' ? { data: query } : query

    return new Promise((resolve, reject) => {
      api[HTTPMethod](endpoint, body)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}

const nextAction = (action, data) => {
  const next = merge({}, action, data)
  delete next[API_CALL]
  return next
}

export default store => next => action => {
  if (action.type !== API_CALL || !action.fields) return next(action)
  const {
    url,
    endpoint,
    headers,
    method,
    query,
    types,
    qsParams,
    callback,
  } = action.fields

  const signature = Date.now()

  const token = getAccessToken(store.getState())

  const completeHeaders = assign(
    isEmpty(query) && { 'Content-Type': 'application/json' },
    token && (!url || url === apiConfig.SERVER)
      ? {
          Authorization: `Bearer ${token}`,
        }
      : {},
    headers
  )

  const fsaFields = pick(action.fields, 'payload', 'error', 'meta')

  const isLoadRequest =
    !method ||
    method.toUpperCase() === 'GET' ||
    method.toUpperCase() === 'PATCH' ||
    method.toUpperCase() === 'POST'

  next(
    nextAction(fsaFields, {
      type: types.REQUEST,
      meta: merge(
        { signature },
        isLoadRequest && { endpoint, isRequest: true }
      ),
    })
  )

  const onError = error => {
    const data = {
      payload: error,
      type: types.FAILURE,
      meta: {
        signature,
        httpCode: error.status,
        endpoint,
      },
      error: true,
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const responseCode = get(error, 'response.status', null)

    // if (responseCode === 4001 || error.message === 'Network Error') {
    //   if (!eq(types, UPDATE_TOKEN)) {
    //     next({
    //       type: API_CALL_FAILURE,
    //       failedAction: action,
    //     })
    //   } else {
    //     store.dispatch({
    //       type: LOG_OUT.REQUEST,
    //     })
    //   }
    // } else {
    if (isFunction(callback))
      callback(get(error, 'response.data', error), error)
    const errorCode =
      error.response.data.code || error.response.data.message || error.message
    const errorMessages = [errorCode]
    if (error.response.data.code === 'UserExistsException') {
      if (error.response.data.details.indexOf('email') !== -1) {
        errorMessages.push('UserExistsExceptionEmail')
      }
      if (error.response.data.details.indexOf('phone_number') !== -1) {
        errorMessages.push('UserExistsExceptionPhoneNumber')
      }
      if (error.response.data.details.indexOf('username') !== -1) {
        errorMessages.push('UserExistsExceptionUserName')
      }
    }
    // toast.error(
    //   <NamespacesConsumer ns={['apiErrors']}>
    //     {t => (
    //       <div>
    //         {errorMessages.map((errorCodeName, index) => (
    //           <p key={index}>{t(errorCodeName)}</p>
    //         ))}
    //       </div>
    //     )}
    //   </NamespacesConsumer>
    // )
    next(nextAction(fsaFields, data))
    // }
    return data
  }

  const onSuccess = response => {
    const meta = merge(
      { signature },
      isLoadRequest && { endpoint, isSuccess: true }
    )
    const payload = get(response, 'data')
    const data = { meta, payload, type: types.SUCCESS }

    if (isFunction(callback)) {
      callback(null, payload)
    }

    next(nextAction(fsaFields, data))

    return data
  }

  const apiRequest = ApiService.apiCall(
    url,
    endpoint,
    method,
    query,
    completeHeaders,
    qsParams
  )

  return apiRequest
    .then(onSuccess, onError)
    .catch(error => console.error('Request error', error))
}
